import React, { useEffect, useState } from 'react';
import { applySeo } from '../utils/seoManager';
import './BlogList.css';

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    applySeo({
      seoTitle: 'Blog | Smart Telecom Store',
      metaDescription: 'Latest news, tips and guides from Smart Telecom Store.',
    });
    fetch('/api/blog')
      .then((r) => r.json())
      .then(setPosts)
      .catch(console.error);
  }, []);

  const navigate = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const filtered = filter
    ? posts.filter((p) => p.categories?.includes(filter) || p.tags?.includes(filter))
    : posts;

  const categories = [...new Set(posts.flatMap((p) => p.categories || []))];

  return (
    <div className="blog-list-page">
      <h1>Blog</h1>
      <div className="blog-filters">
        <button type="button" className={!filter ? 'active' : ''} onClick={() => setFilter('')}>All</button>
        {categories.map((c) => (
          <button key={c} type="button" className={filter === c ? 'active' : ''} onClick={() => setFilter(c)}>{c}</button>
        ))}
      </div>
      <div className="blog-grid">
        {filtered.map((post) => (
          <article key={post._id} className="blog-card" onClick={() => navigate(`/blog/${post.slug}`)}>
            {post.featuredImage && <img src={post.featuredImage} alt={post.featuredImageAlt || post.title} />}
            <h2>{post.title}</h2>
            <p>{post.excerpt}</p>
            <time>{new Date(post.publishDate).toLocaleDateString()}</time>
          </article>
        ))}
      </div>
    </div>
  );
};

export default BlogList;
